import { Horizontal, MomentTimePicker, Texto } from '@gravitate-js/excalibrr'
import { Checkbox, Form, type FormInstance, TimePicker } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

import type { OutageForm } from '../types'

type WeekdaySelectOptionsProps = {
  form: FormInstance<OutageForm>
}

export function WeekdaySelectOptions({ form }: WeekdaySelectOptionsProps) {
  const [weekdayError, setWeekdayError] = useState(false)
  const [weekdays, setWeekdays] = useState([
    { name: 'Monday', selected: false },
    { name: 'Tuesday', selected: false },
    { name: 'Wednesday', selected: false },
    { name: 'Thursday', selected: false },
    { name: 'Friday', selected: false },
    { name: 'Saturday', selected: false },
    { name: 'Sunday', selected: false },
  ])

  useEffect(() => {
    const formFields = form.getFieldValue(['schedule_local', 'days'])
    if (formFields) {
      setWeekdays((prevWeekdays) =>
        prevWeekdays.map((day) => ({
          ...day,
          selected: formFields[day.name].enabled,
        }))
      )
    }
  }, [form])

  const handleWeekdayToggle = (index: number) => {
    setWeekdays((prevWeekdays) =>
      prevWeekdays.map((day, i) => (i === index ? { ...day, selected: !day.selected } : day))
    )
  }

  return (
    <div>
      <Form.Item
        noStyle
        name={['schedule_local', 'days']}
        rules={[
          {
            required: true,
            validator: async () => {
              const selectedDays = weekdays.filter((day) => day.selected)
              if (selectedDays.length > 0) {
                setWeekdayError(false)
                return Promise.resolve()
              }
              setWeekdayError(true)
              return Promise.reject()
            },
          },
        ]}
      >
        {weekdays.map((day, index) => (
          <Form.Item noStyle key={day.name}>
            <Horizontal>
              <Form.Item
                name={['schedule_local', 'days', day.name, 'enabled']}
                valuePropName='checked'
                style={{ display: 'flex', flex: 1 }}
              >
                <Checkbox onChange={() => handleWeekdayToggle(index)}>{day.name}</Checkbox>
              </Form.Item>
              <Form.Item noStyle dependencies={[['schedule_local', 'days', day.name, 'enabled']]}>
                {({ getFieldValue }) => {
                  const isEnabled = getFieldValue(['schedule_local', 'days', day.name, 'enabled']) as boolean
                  return (
                    <Horizontal>
                      <Form.Item
                        name={['schedule_local', 'days', day.name, 'start_time']}
                        className='mr-2'
                        initialValue={moment().startOf('day')}
                      >
                        <MomentTimePicker format='hh:mm a' disabled={!isEnabled} />
                      </Form.Item>

                      <Texto weight='bold' style={{ paddingTop: '8px' }}>
                        —
                      </Texto>

                      <Form.Item
                        name={['schedule_local', 'days', day.name, 'end_time']}
                        className='ml-2'
                        initialValue={moment().endOf('day')}
                      >
                        <MomentTimePicker format='hh:mm a' disabled={!isEnabled} />
                      </Form.Item>
                    </Horizontal>
                  )
                }}
              </Form.Item>
            </Horizontal>
          </Form.Item>
        ))}
      </Form.Item>
      {weekdayError && <Texto style={{ color: '#FF4D4F' }}>Select at least one day</Texto>}
    </div>
  )
}
